/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps & {
  onClick: () => void;
};

export const CropImageModalRotateIcon: FC<Props> = ({ className, onClick }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4698 8.47709C20.7621 8.76939 20.7621 9.24331 20.4698 9.53561L17.5375 12.4679C17.3782 12.6272 17.1199 12.6272 16.9606 12.4679L14.0283 9.53561C13.736 9.24331 13.736 8.76939 14.0283 8.47709C14.3202 8.18518 14.7933 8.18473 15.0858 8.47606L16.499 9.88385V6.00635C16.4978 5.01215 16.1024 4.05902 15.3994 3.35601C14.6964 2.65301 13.7432 2.25754 12.749 2.25635H9.74902C9.33481 2.25635 8.99902 1.92056 8.99902 1.50635C8.99902 1.09213 9.33481 0.756348 9.74902 0.756348H12.749C14.1409 0.757936 15.4754 1.31157 16.4596 2.29579C17.4438 3.28001 17.9974 4.61445 17.999 6.00635V9.88385L19.4123 8.47606C19.7047 8.18473 20.1779 8.18518 20.4698 8.47709ZM1.61902 19.1363V8.37635H10.379V19.1363H1.61902ZM-0.000976562 7.65635C-0.000976562 7.15929 0.401967 6.75635 0.899023 6.75635H11.099C11.5961 6.75635 11.999 7.15929 11.999 7.65635V19.8563C11.999 20.3534 11.5961 20.7563 11.099 20.7563H0.899023C0.401967 20.7563 -0.000976562 20.3534 -0.000976562 19.8563V7.65635Z"
      fill="#272756"
    />
  </svg>
);
